export default "__VITE_ASSET__DXZsQXJ$__"